// =====================================================================
// Validité des tâches par date de prestation — catalogue de Luca au 01/11/2026
// (même règle que backend/src/lib/validite-taches.js : le serveur refuse ce que l'écran ne propose pas)
//   validFrom : la tâche n'existe qu'à partir de ce jour ; validTo : elle ne s'utilise plus après ce jour.
//   Vides = valable tout le temps.
// =====================================================================

const YMD = /^\d{4}-\d{2}-\d{2}$/;

export function tacheValableLe(tache, date) {
  if (!tache || !date || !YMD.test(date)) return true;
  if (tache.validFrom && date < tache.validFrom) return false;
  if (tache.validTo && date > tache.validTo) return false;
  return true;
}

/**
 * Les tâches proposables pour une ligne datée `date`. `garderId` : la tâche actuelle d'une ligne existante,
 * gardée dans la liste même hors période (on corrige une ligne sans être forcé de changer sa tâche).
 */
export function tachesValables(taches, date, garderId = null) {
  return (taches || []).filter((t) => t.id === garderId || tacheValableLe(t, date));
}

/**
 * La date a changé : la tâche choisie reste-t-elle possible ? Sinon, sa remplaçante si elle est valable
 * (ancienne → nouvelle au 01/11, ou nouvelle → ancienne si on revient en octobre), sinon rien.
 */
export function tacheApresChangementDeDate(taches, taskId, date) {
  if (!taskId) return '';
  const t = (taches || []).find((x) => x.id === taskId);
  if (!t) return '';
  if (tacheValableLe(t, date)) return taskId;
  const suivante = (taches || []).find((x) => x.id === t.replacedById && tacheValableLe(x, date));
  if (suivante) return suivante.id;
  const precedente = (taches || []).find((x) => x.replacedById === t.id && tacheValableLe(x, date));
  return precedente ? precedente.id : '';
}

/** JJ/MM/AAAA. */
function fr(ymd) {
  return `${ymd.slice(8, 10)}/${ymd.slice(5, 7)}/${ymd.slice(0, 4)}`;
}

/** « valable à partir du 01/11/2026 », « jusqu'au 31/10/2026 », « du … au … », ou '' (sans limite). */
export function texteValidite(t) {
  if (!t) return '';
  if (t.validFrom && t.validTo) return `du ${fr(t.validFrom)} au ${fr(t.validTo)}`;
  if (t.validFrom) return `à partir du ${fr(t.validFrom)}`;
  if (t.validTo) return `jusqu'au ${fr(t.validTo)}`;
  return '';
}
